import React from 'react';
import { View } from 'react-native';

import { Icon } from '../icon';
import TypographyParagraph from '../typography/TypographyParagraph';
import { useThemedStyles } from '../../hooks/useThemedStyles';

export const InformationCallout = ({ text }) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={styles.container}>
			<Icon
				name="exclamation"
				color={styles.iconColor.color}
				size={14}
				style={styles.icon}
			/>
			<TypographyParagraph
				style={styles.text}
				text={text}
			/>
		</View>
	);
};

const createStyles = ({ ui: { colors, radius, type } }) => ({
	container: {
		flexDirection: 'row',
		alignItems: 'flex-start',
		backgroundColor: colors.chip,
		paddingVertical: 10,
		paddingHorizontal: 12,
		borderRadius: radius.control,
		marginBottom: 8,
		borderColor: colors.chip,
		borderWidth: 1,
	},
	icon: {
		marginLeft: 2,
		marginRight: 8,
		marginTop: 3,
		alignSelf: 'flex-start',
	},
	iconColor: {
		color: colors.onChip,
	},
	text: {
		...type.bodySmallStrong,
		color: colors.onChip,
	},
});
